import { Discount } from "./Discount";

export class TimeSlot {
    public id?: number;
    public benefitId?: number;
    public startMillis: number;
    public endMillis: number;
    public discount: Discount;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
